<template>
  <div>
    <div class="head g-flex g-flex-ac g-flex-sb">
      <div class="logo-container g-flex g-flex-ac g-flex-cc ">
        <img
          src="@/assets/img/logo.png"
          class="logo"
        >
      </div>
      <div class="right g-flex g-flex-ac ">
        <!-- <p>您好，<span>{{username}}-{{agentName}}</span></p> -->
        <!-- <div
          class="btn g-flex g-flex-ac g-flex-cc"
          @click="goBack"
        /> -->
        <div class="btn g-flex g-flex-ac g-flex-cc">
          <el-dropdown @command="handleCommand">
            <div class="__width g-flex g-flex-ac g-flex-cc">
              <i class="iconfont icon-addressbook_fill __white __font" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="__dropdown-content">
                <div class="__dropdown-item">
                  <h1>{{ username }}，欢迎您</h1>
                  <p class="g-ellipsis">{{ agentName }}</p>
                </div>
                <el-dropdown-item command="updatePwd">
                  <div class="__dropdown-item">
                    <i class="iconfont icon-lock" />修改密码
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="logout">
                  <div class="__dropdown-item">
                    <i class="iconfont icon-tuichu" />退出登录
                  </div>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import createPopup from '@/utils/popup-fun/index.js';
  import changePwd from './change-password.vue';

  export default {
    data() {
      return {
        username: '二五七',
        agentName: ''
      };
    },
    mounted() {
      this.username = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).name;
      // this.agentName = JSON.parse(localStorage.getItem('userInfo')).agentName
    },
    methods: {
      handleCommand(command) {
        if (command == 'updatePwd') {
          createPopup(changePwd);
        } else if (command == 'logout') {
          this.handleLogout();
        }
      },
      handleLogout() {
        this.$confirm('确定要退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            url: '/user/loginOut.htm',
            method: 'POST',
          }).then(res => {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userInfo');
            this.$store.dispatch('clearPremission');
            this.$router.push('/login');
          });
        });
      },
      goBack() {
        location.href = '//admin.zhiyao12.com';
      }
    },
  };

</script>
<style lang="scss" scoped>
  /deep/ .el-dropdown-menu__item {
    padding: 0;
  }
  .__font {
    font-size: 20px;
  }

  .__dropdown-item {
    width: 224px;
    padding: 14px 15px;
    border-bottom: 1px solid rgba(246, 247, 249, 1);

    h1 {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
    }

    p {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
      line-height: 16px;
    }

    i {
      padding-right: 20px;
    }
  }

  .head {
    height: 60px;
    width: 100%;
    background: #289cef;
    position: relative;

    .logo-container {
      width: 250px;
      height: 60px;
    }

    .logo {
      // width: 220px;
      width: 245px;
      height: 44px;
      margin-left: 22px;
      display: block;
    }

    .__width {
      width: 40px;
      height: 40px;
    }

    .__white {
      color: #fff;
    }

    .right {
      // margin-right: 30px;

      p {
        font-size: 18px;
        color: #fff;
        line-height: 60px;
      }

      .btn {
        i {
          display: block;
        }

        width: 60px;
        height: 60px;
        border-left: 1px solid rgba(50, 163, 243, 1);
        text-align: center;
        color: #fff;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue